

import React from "react";
import { X } from "lucide-react";
import { PALETTE } from "@/app/lib/colorPallete";

interface CloseButtonProps {
  onClose: () => void;
}

export const CloseButton: React.FC<CloseButtonProps> = ({ onClose }) => {
  return (
    <button
      onClick={onClose}
      className="absolute top-3 right-3 z-20 w-8 h-8 flex items-center justify-center rounded-full transition-colors"
      style={{
        backgroundColor: `${PALETTE.darkGreen}20`,
        color: PALETTE.darkGreen,
      }}
    >
      <X size={20} />
    </button>
  );
};